import { render } from "./CateringView.vue?vue&type=template&id=2ea78003"
import script from "./CateringView.vue?vue&type=script&lang=js"
export * from "./CateringView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__